import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './admin/AdminApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Admin dashboard lives at /#/admin (hash route: works without server-side SPA fallback).
const isAdmin = window.location.hash.startsWith('#/admin') || window.location.pathname.startsWith('/admin');

// Switching between the public scanner and admin via the URL hash needs a full re-render.
window.addEventListener('hashchange', () => {
  const nowAdmin = window.location.hash.startsWith('#/admin');
  if (nowAdmin !== isAdmin) window.location.reload();
});

root.render(
  <React.StrictMode>
    {isAdmin ? <AdminApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
